import { HttpMethod } from "./baseHttpService";

export default class GeneralService {
  constructor(
    apiService
  ) {
    this.apiService = apiService;
  }

  async getLandingData() {
    const response = await this.apiService.request({
      method: HttpMethod.GET,
      url: `home`,
    });
    return response;
  }
}


